import Axios, { AxiosError } from 'axios';

import { baseAccountsUrl, marketUrl, redirectMarketUrl } from '../utils/constants';
import { links } from '../utils/constants/links';

let refreshTokenPromise: void | null | Promise<void>; // this holds any in-progress token refresh requests
let startRefresh: boolean | null = null;

export const axios = Axios.create({
  baseURL: marketUrl,
  withCredentials: true,
});

axios.interceptors.response.use(
  (response) => {
    refreshTokenPromise = undefined;
    return response.data;
  },
  async (error: AxiosError) => {
    if (
      (error.response?.status === 403 && !refreshTokenPromise && startRefresh === null) ||
      (error.response?.status === 401 && !refreshTokenPromise && startRefresh === null)
    ) {
      try {
        startRefresh = true;
        refreshTokenPromise = await axios.get(links.refresh, { baseURL: baseAccountsUrl });
        startRefresh = null;
      } catch (e) {
        startRefresh = false;

        if (
          typeof window !== 'undefined' &&
          window.location.href !== `${redirectMarketUrl}${links.logIn}`
        ) {
          const currentUrl = window.location.href;
          const isAlreadyOnLoginPage = currentUrl.includes(`${redirectMarketUrl}${links.logIn}`);

          if (!isAlreadyOnLoginPage) {
            window.location.href = `${redirectMarketUrl}${
              links.logIn
            }?redirectUrl=${encodeURIComponent(currentUrl)}`;
          }
        }
      }
    }
    throw error;
  }
);
